"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearContext = clearContext;
exports.getContext = getContext;
exports.getIframeConfiguration = getIframeConfiguration;
exports.setTargetOrigin = setTargetOrigin;
var _error = require("./error");
var _coreUrl = _interopRequireDefault(require("../core-url"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } /*
* Copyright (c) 2020 Wells Fargo, All rights reserved.
*
* This software is the confidential and proprietary information of Wells Fargo
* bank. ('Confidential Information'). You shall not disclose such Confidential
* Information and shall use it only in accordance with the terms of the license
* agreement you entered into with WellsFargo.
*/ /**
 * Resize IFrame Handler
 * - resizes the SDK iframe
 *
 * @module core-bootstrap-context
 */
/**
 * Internal configuration object
 *
 * iframes: [
 *   {
 *     id: id,
 *     handle: handle,
 *     element: element,
 *     nonce: nonce,
 *     config: config,
 *   },
 * ]
 */
var internalConf = {
  iframeTargetOrigin: undefined,
  iframes: []
};

/**
 * Sets the internal iframe target origin
 *
 * @param {string} url The URL to extract a target origin from
 */
function setTargetOrigin(url) {
  var parsedSDKUrl = (0, _coreUrl["default"])(url);
  internalConf.iframeTargetOrigin = parsedSDKUrl.protocol + '//' + parsedSDKUrl.hostname + (parsedSDKUrl.port ? ':' + parsedSDKUrl.port : '');
}

/**
 * Get the internal context
 *
 * @return {*} The internal context
 */
function getContext() {
  return internalConf;
}

/**
 * Clear the internal context
 */
function clearContext() {
  // make sure internal configuration is reset to original state
  internalConf.iframeTargetOrigin = null;
  internalConf.iframes = [];
}

/**
 * Look up the internal configuration for this iframeid. If no
 * iframeID is provided AND only one iframe exists, they that one
 * iframe configuration is returned.
 *
 * @param {string} iframeId The ID of an iframe
 * @return {*} iframe entry object with configuration data
 */
function getIframeConfiguration(iframeId) {
  if (!iframeId) {
    var numInstances = internalConf.iframes.length;
    // if we have only one iframe, use it
    if (numInstances === 1) {
      return internalConf.iframes[0];
    }
    (0, _error.handleError)('An IFRAME/SDK ID must be provided.');
    return null;
  }

  // find the iframe configuratino for the specified iframeID
  var _iterator = _createForOfIteratorHelper(internalConf.iframes),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var entry = _step.value;
      if (entry.id === iframeId) {
        return entry;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  (0, _error.handleError)('Unrecognized IFRAME/SDK ID was provided.');
  return null;
}
//# sourceMappingURL=context.js.map